module.exports = __webpack_public_path__ + "img/JMMP_Website_Projects_Typefaces_03_JM-04.389065c7.svg";